import React from 'react';
import PropTypes from 'prop-types';
import {
  groupBy,
  map,
  sortBy,
} from 'lodash';
import {
  withStyles,
  Button,
  Icon,
  Menu,
  MenuItem,
  ListSubheader,
  ListItemIcon,
  ListItemText,
  Link,
  Divider,
} from '@material-ui/core';
import styles from './styles';
import { getIconForView } from '../DashboardViewSelector/defaultViews';
import { getEventTemplateDashboard } from '../../../../utils/dashboardHelper';

export const groupDashboard = (dashboards, eventTemplates, showAllEventsDashboard) => {
  if (dashboards.length === 0) {
    return null;
  }

  const [allEvents, ...createdDashboards] = dashboards;
  const mapppedDashboards = groupBy((showAllEventsDashboard
    ? createdDashboards
    : dashboards)
    .map((dashboard) => ({
      ...dashboard,
      group: dashboard.organizationExposed
        ? 'shared'
        : 'private',
    })), 'group');

  const commonDashboardGroups = [
    {
      key: 'shared',
      label: 'Shared Dashboards',
      dashboards: mapppedDashboards.shared,
    }, {
      key: 'private',
      label: 'Private Dashboards',
      dashboards: mapppedDashboards.private,
    },
    {
      key: 'workflows',
      label: 'Workflows',
      dashboards: eventTemplates.map((eventTemplate) => getEventTemplateDashboard(eventTemplate)),
    },
  ];

  if (showAllEventsDashboard) {
    return [
      {
        key: 'default',
        dashboards: [allEvents],
      },
      ...commonDashboardGroups,
    ];
  }
  return commonDashboardGroups;
};

class DashboardSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = { menuElement: null };
  }

  handleClick = (event) => {
    this.setState({ menuElement: event.currentTarget });
  }

  handleClose = () => {
    this.setState({ menuElement: null });
  }

  handleSelectorChange = (dashboard) => {
    this.handleClose();
    if (dashboard.id !== this.props.selectedDashboard.id) {
      this.props.onDashboardChange({ ...dashboard });
    }
  }

  render() {
    const {
      dashboards,
      selectedDashboard,
      classes,
      showAllEventsDashboard,
      eventTemplates,
    } = this.props;
    const { menuElement } = this.state;

    const groups = groupDashboard(dashboards, eventTemplates, showAllEventsDashboard);

    return (
      <div className={classes.container}>
        <Button
          aria-owns={menuElement
            ? 'dashboard-selector-menu'
            : null}
          aria-haspopup="true"
          className={classes.button}
          name="dashboard-selector"
          onClick={this.handleClick}
          color="inherit"
        >
          <span className="selected-dashboard">{selectedDashboard.name}</span>
          <Icon>
            arrow_drop_down
          </Icon>
        </Button>
        <Menu
          id="dashboard-selector-menu"
          anchorEl={menuElement}
          open={Boolean(menuElement)}
          onClose={this.handleClose}
        >
          {
            groups
            && groups.map((group) => (
              <div key={`dashboard-group-${group.key}`}>
                {
                  group.label
                    && (group.dashboards && group.dashboards.length > 0)
                    && (
                      <ListSubheader
                        component="div"
                        disableSticky
                        disableGutters
                        className={classes.listSubheader}
                      >
                        {group.label}
                      </ListSubheader>
                    )
                }
                {
                  map(sortBy(group.dashboards, ['name']), (dashboard) => (
                    <MenuItem
                      key={`dashboard-selector-${dashboard.id}`}
                      onClick={() => this.handleSelectorChange(dashboard)}
                      className={classes.menuItem}
                    >

                      <ListItemIcon>
                        <Icon>{getIconForView(dashboard.defaultView)}</Icon>
                      </ListItemIcon>
                      <ListItemText className={classes.menuItemText}>{dashboard.name}</ListItemText>
                    </MenuItem>
                  ))
                }
              </div>
            ))
          }
          <Divider />
          <Link
            to="/settings/my-dashboards"
            href="/settings/my-dashboards"
            tabIndex={-1}
          >
            <MenuItem
              key="dashboard-selector-new"
              className={classes.menuItem}
            >

              <ListItemIcon>
                <Icon>add</Icon>
              </ListItemIcon>
              <ListItemText className={classes.menuItemCreateDashboardText}>
                Create Dashboard
              </ListItemText>
            </MenuItem>
          </Link>
        </Menu>
      </div>
    );
  }
}

DashboardSelector.propTypes = {
  dashboards: PropTypes.array,
  selectedDashboard: PropTypes.object,
  classes: PropTypes.object,
  onDashboardChange: PropTypes.func,
  showAllEventsDashboard: PropTypes.bool,
  eventTemplates: PropTypes.array,
};

DashboardSelector.defaultProps = {
  dashboards: [],
  selectedDashboard: {},
  classes: {},
  onDashboardChange: () => {},
  showAllEventsDashboard: true,
  eventTemplates: [],
};

export default withStyles(styles)(DashboardSelector);
